<div class="edit-profile-dialog">
    <div class="edit-profile-dialog__header" mat-dialog-title>
        <h2>Edit Profile</h2>

        <button class="text-secondary" mat-dialog-close mat-icon-button type="button" [disabled]="saving">
            <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <mat-dialog-content class="edit-profile-dialog__content">
        <div class="edit-profile-dialog__tabs">
            <button
                class="edit-profile-dialog__tab"
                type="button"
                [ngClass]="{'edit-profile-dialog__tab--active': activeTab === 'profile'}"
                (click)="setActiveTab('profile')">
                User Profile
            </button>
            <button
                class="edit-profile-dialog__tab"
                type="button"
                [ngClass]="{'edit-profile-dialog__tab--active': activeTab === 'password'}"
                (click)="setActiveTab('password')">
                Password
            </button>
        </div>

        <div
            *ngIf="message"
            class="edit-profile-dialog__message"
            [ngClass]="{
                'edit-profile-dialog__message--success': message.type === 'success',
                'edit-profile-dialog__message--error': message.type === 'error'
            }">
            {{ message.text }}
        </div>

        <form
            *ngIf="activeTab === 'profile'"
            class="edit-profile-dialog__form"
            [formGroup]="profileForm"
            (ngSubmit)="saveProfile()">
            <label class="edit-profile-dialog__field">
                <span>E-Mail</span>
                <input class="edit-profile-dialog__input" type="email" formControlName="email">
            </label>

            <label class="edit-profile-dialog__field">
                <span>First Name*</span>
                <input class="edit-profile-dialog__input" formControlName="firstName" required>
            </label>
            <div class="edit-profile-dialog__error" *ngIf="profileForm.get('firstName').touched && profileForm.get('firstName').hasError('required')">
                First name is required
            </div>

            <label class="edit-profile-dialog__field">
                <span>Last Name*</span>
                <input class="edit-profile-dialog__input" formControlName="lastName" required>
            </label>
            <div class="edit-profile-dialog__error" *ngIf="profileForm.get('lastName').touched && profileForm.get('lastName').hasError('required')">
                Last name is required
            </div>

            <label class="edit-profile-dialog__field">
                <span>Phone Number</span>
                <div class="edit-profile-dialog__phone">
                    <span class="edit-profile-dialog__phone-prefix">+1</span>
                    <input
                        class="edit-profile-dialog__input edit-profile-dialog__input--phone"
                        type="tel"
                        inputmode="numeric"
                        maxlength="12"
                        placeholder="XXX-XXX-XXXX"
                        formControlName="phoneNumber"
                        (input)="onPhoneInput($event)">
                </div>
            </label>
            <div class="edit-profile-dialog__error" *ngIf="profileForm.get('phoneNumber').touched && profileForm.get('phoneNumber').hasError('phoneNumber')">
                Enter a valid 10-digit phone number.
            </div>

            <button class="edit-profile-dialog__submit" type="submit" [disabled]="!canSaveProfile" aria-hidden="true"></button>
        </form>

        <form
            *ngIf="activeTab === 'password'"
            class="edit-profile-dialog__form"
            [formGroup]="passwordForm"
            (ngSubmit)="savePassword()">
            <label
                class="edit-profile-dialog__field"
                [ngClass]="{'edit-profile-dialog__field--error': passwordForm.get('currentPassword').touched && passwordForm.get('currentPassword').hasError('required')}">
                <span>Current Password*</span>
                <input
                    class="edit-profile-dialog__input edit-profile-dialog__input--with-action"
                    [type]="hideCurrentPassword ? 'password' : 'text'"
                    formControlName="currentPassword"
                    required>
                <button
                    class="edit-profile-dialog__field-action"
                    mat-icon-button
                    type="button"
                    (click)="hideCurrentPassword = !hideCurrentPassword">
                    <mat-icon
                        *ngIf="hideCurrentPassword"
                        [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                    <mat-icon
                        *ngIf="!hideCurrentPassword"
                        [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                </button>
            </label>
            <div class="edit-profile-dialog__error" *ngIf="passwordForm.get('currentPassword').touched && passwordForm.get('currentPassword').hasError('required')">
                Current password is required
            </div>

            <label class="edit-profile-dialog__field">
                <span>New Password*</span>
                <input
                    class="edit-profile-dialog__input edit-profile-dialog__input--with-action"
                    [type]="hideNewPassword ? 'password' : 'text'"
                    formControlName="newPassword"
                    minlength="6"
                    required>
                <button
                    class="edit-profile-dialog__field-action"
                    mat-icon-button
                    type="button"
                    (click)="hideNewPassword = !hideNewPassword">
                    <mat-icon
                        *ngIf="hideNewPassword"
                        [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                    <mat-icon
                        *ngIf="!hideNewPassword"
                        [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                </button>
            </label>
            <div class="edit-profile-dialog__error" *ngIf="passwordForm.get('newPassword').touched && passwordForm.hasError('newPasswordRequired')">
                New password is required
            </div>
            <div class="edit-profile-dialog__error" *ngIf="passwordForm.get('newPassword').touched && passwordForm.get('newPassword').hasError('minlength')">
                New password should be at least 6 characters.
            </div>

            <label
                class="edit-profile-dialog__field"
                [ngClass]="{'edit-profile-dialog__field--error': passwordForm.get('confirmNewPassword').touched && passwordForm.hasError('passwordMismatch')}">
                <span>Confirm New Password*</span>
                <input
                    class="edit-profile-dialog__input edit-profile-dialog__input--with-action"
                    [type]="hideConfirmPassword ? 'password' : 'text'"
                    formControlName="confirmNewPassword"
                    required>
                <button
                    class="edit-profile-dialog__field-action"
                    mat-icon-button
                    type="button"
                    (click)="hideConfirmPassword = !hideConfirmPassword">
                    <mat-icon
                        *ngIf="hideConfirmPassword"
                        [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                    <mat-icon
                        *ngIf="!hideConfirmPassword"
                        [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                </button>
            </label>
            <div class="edit-profile-dialog__error" *ngIf="passwordForm.get('confirmNewPassword').touched && passwordForm.hasError('passwordMismatch')">
                Passwords must match
            </div>

            <button class="edit-profile-dialog__submit" type="submit" [disabled]="!canSavePassword" aria-hidden="true"></button>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="edit-profile-dialog__actions">
        <button mat-button mat-dialog-close type="button" [disabled]="saving">Cancel</button>
        <button
            mat-flat-button
            color="primary"
            type="button"
            [disabled]="activeTab === 'profile' ? !canSaveProfile : !canSavePassword"
            (click)="activeTab === 'profile' ? saveProfile() : savePassword()">
            <span *ngIf="!saving">Save</span>
            <mat-progress-spinner
                *ngIf="saving"
                [diameter]="22"
                [mode]="'indeterminate'"></mat-progress-spinner>
        </button>
    </mat-dialog-actions>
</div>
